import currencies from "@/consts/currencies"
import getFormattedPrice from "@/utils/getFormattedPrice"
import getPriceWithCurrency from "@/utils/getPriceWithCurrency"

const price = {
  data() {
    return {
      currencies
    }
  },
  methods: {
    getFormattedPrice,
    getPriceWithCurrency
  }
}

export default price
